import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-upload-button',
  templateUrl: './upload-button.component.html',
  styleUrls: ['./upload-button.component.scss'],
  standalone: false
})
export class UploadButtonComponent {

  @Input() icon!: string;
  @Input() text?: string;
  @Input() action: 'camera' | 'gallery' = 'gallery';
  @Output() filesChanged = new EventEmitter<File[]>();

  onFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!input.files) return;

    const files = Array.from(input.files);
    this.filesChanged.emit(files);
  }
}